module.exports = __webpack_public_path__ + "md.svg?06e48865e1de32e108d473fb7dd7f488";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/md.svg
// module id = 1065
// module chunks = 27